import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";

import { FMSLogger } from "FMSLogger";
import { sendSentryEvent } from "./sentryUtils";
import { BASE } from "./api";
import { withCognitoRefresh } from "./cognitoRefresh";

const networkLogger = FMSLogger.byPrefix("network-logs");

const instance = axios.create({
  baseURL: BASE,
});

instance.defaults.headers.common["Authorization"] =
  window.localStorage.getItem("JWT");

instance.interceptors.response.use(
  (response) => {
    networkLogger.debug(
      "API response",
      response.config.url as string,
      response.data
    );
    return response;
  },
  async (error: AxiosError) => {
    const originalRequest = error.config as InternalAxiosRequestConfig & {
      _retry?: boolean;
    };

    // Handle 401 errors with token refresh (shared with cloud-core api.ts)
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("/login/")
    ) {
      return withCognitoRefresh(originalRequest, instance);
    }

    networkLogger.error(
      "API error",
      error.message,
      error.code ?? "",
      error.config?.url ?? "",
      error.response?.data ?? ""
    );
    if (!axios.isCancel(error)) {
      sendSentryEvent(error, "API error");
    }
    throw error;
  }
);

instance.interceptors.request.use(function (config) {
  const token = window.localStorage.getItem("JWT");
  config.headers.Authorization = token;
  networkLogger.debug(
    "API request",
    config.url as string,
    config.method as string,
    config.data ?? ""
  );
  return config;
});

export default instance;
